import React from 'react';
import { FadeInOnScroll } from './FadeInOnScroll';

/** Scroll-triggered fade/slide reveal for major page blocks (pairs with skeleton initial load). */
export function PageFadeSection({ children, className = '' }) {
  return (
    <FadeInOnScroll className={['block', className].filter(Boolean).join(' ')}>
      {children}
    </FadeInOnScroll>
  );
}
